import React, { useEffect, useCallback } from "react";
import { Box, Typography, CircularProgress } from "@material-ui/core";
import { Search as SearchOffIcon } from "@material-ui/icons";
import { usePdvStyles } from "../styles/pdvStyles";
import PdvProductItem from "./PdvProductItem";
import clsx from "clsx";

const PdvProductList = ({
  products = [],
  selectedIndex = -1,
  onSelectProduct,
  onAddProduct,
  onSendProduct,
  isActive = false,
  isLoading = false,
  listRef,
  emptyMessage = "Digite para buscar produtos...",
  noResultsMessage = "Nenhum produto encontrado",
  hasSearchQuery = false,
  sendingProductId = null,
}) => {
  const classes = usePdvStyles();

  // Auto-scroll to selected item
  useEffect(() => {
    if (selectedIndex >= 0 && listRef?.current) {
      const items = listRef.current.querySelectorAll("[data-product-id]");
      if (items[selectedIndex]) {
        items[selectedIndex].scrollIntoView({
          behavior: "smooth",
          block: "nearest",
        });
      }
    }
  }, [selectedIndex, listRef]);

  const handleItemClick = useCallback(
    (product) => {
      const index = products.findIndex((p) => p.id === product.id);
      if (index >= 0) {
        onSelectProduct(index);
      }
    },
    [products, onSelectProduct]
  );

  const handleAddProduct = useCallback(
    (product, quantity) => {
      if (onAddProduct) {
        onAddProduct(product, quantity);
      }
    },
    [onAddProduct]
  );

  // Loading state
  if (isLoading) {
    return (
      <Box className={classes.productListContainer}>
        <Box className={classes.loadingOverlay}>
          <CircularProgress size={32} />
        </Box>
      </Box>
    );
  }

  // Empty state
  if (products.length === 0) {
    return (
      <Box className={classes.productListContainer}>
        <Box className={classes.emptyState}>
          <SearchOffIcon className={classes.emptyStateIcon} />
          <Typography className={classes.emptyStateText}>
            {hasSearchQuery ? noResultsMessage : emptyMessage}
          </Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box className={classes.productListContainer}>
      <Box
        ref={listRef}
        className={clsx(classes.productList, {
          [classes.productListActive]: isActive,
        })}
      >
        {products.map((product, index) => (
          <PdvProductItem
            key={product.id}
            product={product}
            isSelected={index === selectedIndex}
            onAdd={handleAddProduct}
            onSend={onSendProduct}
            onClick={handleItemClick}
            isSending={sendingProductId === product.id}
          />
        ))}
      </Box>
    </Box>
  );
};

export default React.memo(PdvProductList);
